import { Loader2 } from 'lucide-react';
import React from 'react';
import { cn } from '@/lib/utils';

export interface LoadingOverlayV2Props {
  message?: string;
  open?: boolean;
  withBackdrop?: boolean;
  fullscreen?: boolean;
  size?: number;
}

export const LoadingOverlayV2: React.FC<LoadingOverlayV2Props> = ({
  message = 'Đang tải...',
  open = true,
  withBackdrop = false,
  fullscreen = false,
  size = 40
}) => {
  if (!open) return null;

  const content = (
    <div
      className={cn(
        'z-[99999] flex w-full flex-col items-center justify-center',
        fullscreen ? 'h-screen' : 'h-full',
        withBackdrop ? '' : 'absolute inset-0 bg-white'
      )}
    >
      <Loader2 className='animate-spin text-main' style={{ width: size, height: size, animationDuration: '0.4s' }} />
      <span className='mt-4 text-sm font-medium text-gray-600'>{message}</span>
    </div>
  );

  if (withBackdrop) {
    return (
      <div className='fixed inset-0 z-[99999] flex items-center justify-center bg-slate-900/20 backdrop-blur-[1px]'>
        {content}
      </div>
    );
  }

  return content;
};
export default LoadingOverlayV2;
